import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import createErrorMessage from 'helpers/createErrorMessages';

import {
  createCorporateAccount,
  CreateCorporateAccountPayload,
  uploadAccountLogo,
} from '../accountsServices/CorporateAccountsService';
import { QueryKey, ServerErrorPayload } from '../models';

const useCreateCorporateAccount = (
  setTitle: (title: string) => void,
  onSuccess?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation<
    unknown,
    AxiosError<ServerErrorPayload>,
    CreateCorporateAccountPayload
  >(
    async (params) => {
      const { logoFile, ...accountData } = params;
      const result = await createCorporateAccount(accountData);
      const accountId = result?.data?.id ?? result?.id;

      if (logoFile && accountId) {
        const formData = new FormData();

        formData.append('Payload', logoFile);

        await uploadAccountLogo({
          id: accountId,
          formData,
        });
      }

      return result;
    },
    {
      onSuccess: () => {
        setTitle('Account created!');
        onSuccess?.();
      },
      onError: (error: AxiosError) => {
        const message = createErrorMessage(error);

        setTitle(message);
        console.error(error.message);
      },
      onSettled: () => {
        queryClient.invalidateQueries(QueryKey.GetCorporateAccounts);
      },
    }
  );
};

export default useCreateCorporateAccount;
